import React from "react";
import { MenuItem, SxProps, TextField } from "@mui/material";

import { SelectOption } from "src/shared/config";

type SelectProps = {
  options: SelectOption[];
  onChange: (value: string) => void;
  value: string;
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  sx?: SxProps;
};

export const Select: React.FC<SelectProps> = (props) => {
  const {
    options,
    value,
    onChange,
    label = "",
    disabled = false,
    fullWidth = false,
    sx = {},
  } = props;

  return (
    <TextField
      select
      fullWidth={fullWidth}
      color="primary"
      size="small"
      variant="standard"
      label={label}
      value={value}
      disabled={disabled}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      sx={sx}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
